import script from "./WatchStatusNotice.vue?vue&type=script&lang=ts&setup=true"
export * from "./WatchStatusNotice.vue?vue&type=script&lang=ts&setup=true"

import "./WatchStatusNotice.vue?vue&type=style&index=0&id=10125a73&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10125a73"]])

export default __exports__